import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Box, Typography, Paper, Button, CircularProgress } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';

// Strict route guard: only users with the `server_admin` role pass. Unlike
// AdminRoute (which also admits legacy admin/instructor roles and, for some
// routes, observatory/org admins), this is reserved for server-admin-only
// areas such as the Service Center. The backend enforces the same rule, so
// non-server-admins could not use those endpoints anyway.
const ServerAdminRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (user?.role !== 'server_admin') {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
        }}
      >
        <Paper
          elevation={3}
          sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, maxWidth: 400 }}
        >
          <LockIcon sx={{ fontSize: 64, color: 'text.secondary' }} />
          <Typography variant="h5" gutterBottom>Access Denied</Typography>
          <Typography variant="body1" color="text.secondary" textAlign="center">
            This area is restricted to server administrators.
          </Typography>
          <Button variant="contained" onClick={() => window.history.back()} sx={{ mt: 2 }}>
            Go Back
          </Button>
        </Paper>
      </Box>
    );
  }

  return <Outlet />;
};

export default ServerAdminRoute;
